// extracted by mini-css-extract-plugin
export default {"wrapper":"DExVfYigaODXeiCZsOEJ","icon":"t4oNZN71yiS4_78tvcAE"};